import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export const twoFactorService = {
  async setup() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/2fa/setup`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { secret: string; qrCode: string; backupCodes: string[] };
  },

  async enable(token: string) {
    const authToken = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/2fa/enable`, { token }, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    return res.data as { message: string; backupCodes: string[] };
  },

  async disable(token: string) {
    const authToken = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/2fa/disable`, { token }, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    return res.data as { message: string };
  },

  async getStatus() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/2fa/status`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { enabled: boolean; backupCodesRemaining: number };
  },
};


